import React from 'react'
import './Morelist.css';
import Button from 'react-bootstrap/Button';



const Morelist = () => {
   
  return (
    <>
    <div className="counter-wrapper24">
   
        <div className="counter24">
            <h2 className='count24' >
                Spacification of PP Woven sacks
                <br></br>
             <ul>
             <br></br>
                
                <li>- Different Sizes</li>
                <li>- Any Color</li>
                <li>- Capacity – 25 to 50 kgs</li>
                <li>- GSM- 20-160 GSM</li>
                <li>- Printed or Non – Printed</li>
                <li>- With Or without Gusset</li>
                <li>- Laminated or Un – Laminated</li>
                {/* <li>- Ultrasonic Cut</li> */}
                {/* <li>- UV Stabilized with Corona Treatment</li> */}
             </ul>
             </h2>
           
            {/* <p>Years of Experience</p> */}
            {/* <Button > <a href="/Contact">Contact Us</a></Button> */}
        </div>
       
       
      </div>
    </>
  )
}

export default Morelist
